import { render, staticRenderFns } from "./moreMenu.vue?vue&type=template&id=91636e68&scoped=true&"
import script from "./moreMenu.vue?vue&type=script&lang=js&"
export * from "./moreMenu.vue?vue&type=script&lang=js&"
import style0 from "./moreMenu.vue?vue&type=style&index=0&id=91636e68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91636e68",
  null
  
)

export default component.exports